// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"6933df3d","389":"cf7f5a64","453":"af066b14","455":"4f5e639a","977":"325935cc"}[chunkId] + ".chunk.js";
};